import React from "react";
import { DistributionsContainer } from "../../../containers";

const Distributions = (props) => {
  return <DistributionsContainer {...props} />;
};

export default Distributions;
